// import React from 'react';

export function reactRenderFile() {
	return `import React from 'react';
import csf from './story-link';

export default <RenderCsf csf={csf}/>

// : { csf: ICompactStoryFormat }
function RenderCsf({ csf }) {
	const description = csf['default'];
	const stories = { ...csf };
	delete stories['default'];
	
	return (
		<div>
			{description && <h1>{description.title}</h1>}
		
			{Object.entries(stories).map(([key, story]) => (
				<RenderStory key={key} name={key} Story={story}/>
			))}
		</div>
	);
}

// IStory
function RenderStory({name, Story}) {
	if (!Story) return null;

	try {
		if (React.isValidElement(Story) || ['string', 'number'].includes(typeof Story)) {
			return <div>
				{name && <h2>{name}</h2>}
				{Story}
			</div>;
		}

		//hopefully function or class component
		//could use:
		// string(component).includes('return React.createElement')
		//	(~= function component)
		// !!component.prototype.isReactComponent
		//	(~= class component)
		if (typeof Story === 'function') {
			return <div>
				{name && <h2>{name}</h2>}
				<Story />
			</div>;
		}
	} catch (e) {
		console.error('failed rendering story', e, Story);
	}
	return null;
}`;
}
